$(document).ready(function() {
    $("[data-search]").keyup(function() {
   
         var value = $(this).val().toLowerCase().trim();
        console.log(value)
        $("#for-search .js_for_search").filter(function(){
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            $('#for-search').show();
            $('#blog-search').hide();
            $('.cw-pagination').hide();
              
            });
            if(value == ''){
                $('#blog-search').show();
                $('#for-search').hide();
                $('.cw-pagination').show();
            }
    });

});